import type { PriceChangeItems } from "@/graphql/codegen/graphql"
import { PriceChangeTableVariant } from "@/screens/Pricing/constants"

export const normalizeGetPriceChangeSubmissionResponse = (data: PriceChangeItems[]): PriceChangeItems[] => data

export const normalizeGetPriceChangeItemsResponse = (data: PriceChangeItems[]): PriceChangeItems[] => {
  return data.map((item) => ({
    ...item,
    groups: item.groups.map((group) => ({
      ...group,
      previousAcceptedCost: group.acceptedCost,
      items: group.items.map((priceItem) => ({
        ...priceItem,
        tiers: priceItem.tiers.map((tier) => ({
          ...tier,
          previousPrice: tier.price, // workaround for AK-6212
        })),
      })),
    })),
  }))
}

type PriceChangeItemsNormalizer = (data: PriceChangeItems[]) => PriceChangeItems[]

const PRICE_CHANGE_TABLE_VARIANT_TO_NORMALIZER: Record<PriceChangeTableVariant, PriceChangeItemsNormalizer> = {
  [PriceChangeTableVariant.SubmitPriceChange]: normalizeGetPriceChangeItemsResponse,
  [PriceChangeTableVariant.ReviewSubmission]: normalizeGetPriceChangeSubmissionResponse,
  [PriceChangeTableVariant.RevertSubmission]: normalizeGetPriceChangeSubmissionResponse,
}

export const getPriceChangeItemsNormalizer = (variant: PriceChangeTableVariant): PriceChangeItemsNormalizer =>
  PRICE_CHANGE_TABLE_VARIANT_TO_NORMALIZER[variant]
